<div class="error-container">
    <img src="assets/images/logo.png" alt="ตราสัญลักษณ์ มกอช." class="logo">
    <h1>403</h1>
    <h2>ไม่มีสิทธิ์เข้าถึงหน้านี้</h2>
    <p>คุณไม่มีสิทธิ์ในการเข้าถึงหรือใช้งานหน้านี้</p>
    <a [href]="portalUrl" class="btn btn-primary btn-lg">กลับไปที่ e-Portal</a>
</div>
